import { Route } from 'app/enums';
import { GuardedRoute } from 'app/interfaces/route';
import { lazyRetry } from 'app/utils';

const GameStatisticsPage = lazyRetry(() => import('./pages/GameStatisticsPage'));

export const GameStatisticsRoutes: GuardedRoute[] = [
  {
    path: Route.GameStatistics,
    name: 'Game Statistics',
    component: GameStatisticsPage,
    availability: [],
    guards: [],
  },
];
